import { sentryCaptureException, sharedApiClient } from '@main/services';

import { Account, AccountState } from '@main/shared-exports';

export const hideOrDeleteAccount = async ({
  authToken,
  accountId,
  state,
  onError,
  onSuccess,
}: {
  authToken?: string;
  accountId: string;
  state: AccountState;
  onError?: () => void;
  onSuccess?: () => void;
}) =>
  sharedApiClient<Account[]>({
    method: 'PATCH',
    url: `/user/collection-item`,
    headers: {
      Authorization: authToken,
      'insurely-version': '2024-06-01',
    },
    data: {
      id: accountId,
      state,
    },
  })
    .then((response) => {
      onSuccess?.();
      return response.data;
    })
    .catch((error) => {
      sentryCaptureException(new Error('Error changing state of an account', error));
      onError?.();
    });
